module.exports = __webpack_public_path__ + "static/media/23116692_1638431116232073_2804348843799429034_o-thumb.dbd89c1d.jpg";